import Component from '../abstracts/Component';
import TrackingComponent from '../components/TrackingComponent';

export default class NewsletterLogic extends Component {
  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  get SELECTORS() {
    return {
      input: '[data-newsletter-input]',
      privacyWrapper: '[data-newsletter-privacy-wrapper]',
      newsletterError: '[data-newsletter-error]',
      newsletterErrorType: 'data-newsletter-error-type',
    };
  }

  // EXPORTED LOGIC
  checkSubmit(component) {
    // enable submit
    if (component.privacyCheckbox !== null && component.submitButton !== null) {
      component.privacyCheckbox.addEventListener('click', () => {
        component.submitButton.disabled = !component.privacyCheckbox.checked;
      });
    }
  }

  onFormSubmit(component) {
    if (component.form) {
      component.form.addEventListener('submit', (e) => {
        // preventing submitting form
        e.preventDefault();
        this.subscribeToNewsletter(component);
      });
    }
  }

  // END EXPORTED LOGIC

  // subscribe function
  subscribeToNewsletter(component) {
    // context of logic
    let logicCtx = this;
    // ctx of newsletter component
    let ctx = component;

    // vars
    let $this = component.form; // form
    let url = $this.getAttribute('action'); // form url
    let params = new URLSearchParams(new FormData($this)).toString();
    let newsletterBox = ctx.$component;
    let eventsName = ctx.$component.dataset.jsEvents;
    let $submit = ctx.submitButton;
    // btn loading
    $submit.classList.add('--loading');
    $submit.disabled = true;
    // modal mode
    /*if ($this.closest('.modal').length) {
      url = url + '?xhr=true';
    }*/
    // adding loading class
    newsletterBox.classList.add('--loading');
    // show spinner loader
    ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, { button: $submit });
    //
    params = params.replace('fromFooter=false', 'fromFooter=true'); //TODO: remove after deprecation of firstName and lastName from API
    // Get the input parent element
    const inputParent = $this.querySelector(
      logicCtx.SELECTORS.input
    ).parentNode;
    // Get the privacy flag(s) parent
    const privacyCheckboxesParent = $this.querySelector(
      logicCtx.SELECTORS.privacyWrapper
    );
    // Remove the input email current error state
    inputParent.classList.remove('error');
    // Remove existing error element if are present
    $this
      .querySelectorAll(logicCtx.SELECTORS.newsletterError)
      .forEach((errorElement) => errorElement.remove());
    // ajax call
    ctx
      .$doAjax({
        type: 'POST',
        url: url,
        data: params,
      })
      .done((res) => {
        const html = new DOMParser().parseFromString(res, 'text/html');
        // parse result
        // searching errors
        const error =
          html.querySelector(logicCtx.SELECTORS.newsletterError) !== null;
        // if input has error
        if (error) {
          // get the span element content with the error message
          const spanError = html.querySelector(
            logicCtx.SELECTORS.newsletterError
          );
          // get the error type
          const errorType = spanError.getAttribute(
            logicCtx.SELECTORS.newsletterErrorType
          );
          switch (errorType) {
            case 'privacy':
              // insert error in privacy wrapper
              if (
                !privacyCheckboxesParent.querySelector(
                  logicCtx.SELECTORS.newsletterError
                )
              ) {
                privacyCheckboxesParent.prepend(spanError);
              }
              break;
            case 'email':
            default:
              // putting error class
              inputParent.classList.add('error');
              // insert error in parent's parent
              if (
                !inputParent.parentNode.querySelector(
                  logicCtx.SELECTORS.newsletterError
                )
              ) {
                inputParent.parentNode.appendChild(spanError);
              }
              break;
          }
          // emit event
          ctx.$emit(ctx.$customEvents[eventsName].error, {
            box: newsletterBox,
            html: html,
          });
          // btn reset
          $submit.classList.remove('--loading');
          $submit.disabled = false;
        } else {
          // adding class to show thanks
          newsletterBox.classList.add(ctx.CLASSES.success);
          // emit event
          ctx.$emit(ctx.$customEvents[eventsName].subscribed, {
            box: newsletterBox,
          });
          let trackingComponent = new TrackingComponent();
          trackingComponent.trackAction(
            'newsletterSubscribe',
            $submit.dataset,
            $submit
          );
        }
      })
      .fail(() => {
        console.error(`nl submit error:  ${$(this).serialize()}`);
      })
      .always(() => {
        // removing loading class
        newsletterBox.classList.remove('--loading');
        $submit.classList.remove('--loading');
        // hide spinner loader
        ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
          button: $submit,
        });
      });
  }

  afterSubscription(component) {
    //
  }

  manageNewsletterForm(component) {
    this.checkSubmit(component);
    this.onFormSubmit(component);
  }

  render() {}
}
